import React, { useState } from "react";
import s from "./ActionsPopOver.module.scss";
import { generateConfirmation } from "../../../../../../global components/DestructiveModal/DestruvtiveModal";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../libs/api/Endpoints";
import { generatetoast } from "../../../../../../global components/Toast";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import { SuccessDataType } from "../../../../../../libs/api/types";
import ReusableDrawer from "../../../../../../global components/Drawer/ReuseableDrawer";
import AssignNumber from "../AssignNumber";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";

type PropType = {
  id: string;
  mutate: () => void;
  status: string;
  number: string;
};
function ActionsPopOver({ id, mutate, status, number }: PropType) {
  const token = UseAuthToken();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const { isMutating: disabling, trigger: disableNumber } = useSWRMutation(
    `api/admin/phone-numbers/${id}/disable`,

    swrMutationFetcher,
  );
  const { isMutating: revoking, trigger: revokeNumber } = useSWRMutation(
    `api/admin/phone-numbers/${id}/revoke`,

    swrMutationFetcher,
  );
  const { isMutating: enabling, trigger: enableNumber } = useSWRMutation(
    `api/admin/phone-numbers/${id}/enable`,

    swrMutationFetcher,
  );
  const { isMutating: releasing, trigger: releaseNumber } = useSWRMutation(
    `api/admin/phone-numbers/${id}/release`,

    swrMutationFetcher,
  );
  const handleDisable = async () => {
    try {
      const fetcheArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "PATCH",
        },
      };
      const result: SuccessDataType<any> =
        status === "disabled"
          ? await enableNumber(fetcheArg)
          : await disableNumber(fetcheArg);

      generatetoast("success", result.message);
      mutate();
    } catch (error) {
      const e = parseClientError(error);
      generatetoast("error", e.message);
    }
  };
  const handleRelease = async () => {
    try {
      const fetcheArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "DELETE",
        },
      };
      const result: SuccessDataType<any> = await releaseNumber(fetcheArg);

      generatetoast("success", result.message);
      mutate();
    } catch (error) {
      const e = parseClientError(error);
      generatetoast("error", e.message);
    }
  };
  const handleRevoke = async () => {
    try {
      const fetcheArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "PATCH",
        },
      };
      const result: SuccessDataType<any> = await revokeNumber(fetcheArg);

      generatetoast("success", result.message);
      mutate();
    } catch (error) {
      const e = parseClientError(error);
      generatetoast("error", e.message);
    }
  };
  const handleDrawer = () => {
    setOpenDrawer((prev) => !prev);
  };
  const handleClick = () => {
    if (status === "active") {
      return generateConfirmation(
        "Disable number",
        `You are about to temporarily disable the phone number ${number}. You can re-enable it back.`,
        handleDisable,
        disabling,
        "disable",
      );
    }

    if (status === "disabled") {
      return generateConfirmation(
        "Enable number",
        `You are about to enable the phone number ${number}. You can disable it back.`,
        handleDisable,
        enabling,
        "enable",
      );
    }

    generateResult("error", "Invalid number status");
  };

  return (
    <>
      <div className={s.wrapper}>
        {
          <div className={s.item} onClick={handleClick}>
            {status === "disabled" ? "Enable" : "Disable"}
          </div>
        }
        <div
          className={s.item}
          onClick={() =>
            status === "revoked"|| status === "unassigned"
              ? generateConfirmation(
                  "Release number",
                  `You are about to release the phone number ${number}. This action cannot be undone.`,
                  handleRelease,
                  releasing,
                  "release",
                )
              : generateResult("error", "You can only release a revoked number")
          }
        >
          Release
        </div>
        <div
          className={s.item}
          onClick={() =>
            status === "disabled"
              ? generateConfirmation(
                  "Revoke",
                  `You are about to revoke the phone number ${number}. This action cannot be undone.`,
                  handleRevoke,
                  revoking,
                  "revoke",
                )
              : generateResult("error", "You can only revoke a disabled number")
          }
        >
          Revoke
        </div>
        <div
          className={s.item}
          onClick={() =>
            status === "revoked" || status === "unassigned"
              ? generateConfirmation(
                  "Reassign",
                  `You are about to reassign the phone number ${number}. This action cannot be undone.`,
                  async () => handleDrawer(),
                  true,
                  "reassign",
                )
              : generateResult(
                  "error",
                  "You can only reassign a revoked number",
                )
          }
        >
          Reassign
        </div>
      </div>
      <ReusableDrawer
        Open={openDrawer}
        handleOpen={handleDrawer}
        title="Re-Assign number"
        classNames={{
          body: s.drawerbody,
        }}
      >
        <AssignNumber
          number={number}
          id={id}
          mutate={mutate}
          closeDrawer={handleDrawer}
        />
      </ReusableDrawer>
    </>
  );
}

export default ActionsPopOver;
